import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';

import coachMarkStyles from '@swf/components/CoachMark/CoachMark.scss';
import WebpWithFallback from '@swf/components/WebpWithFallback/WebpWithFallback';

import DismissButton from '../../DismissButton/DismissButton';

import {
  TXTCLI_HoldXem,
  TXTWCL_Group_Video_Chat,
  TXTWCL_See_your_friendsX_and_chat_wit_ELL
} from './VideoChat.messages.json';
import styles from './VideoChat.scss';
import videoChatDesktopClientPNG from './assets/video-chat-desktop-client.png';
import videoChatDesktopClient from './assets/video-chat-desktop-client.webp';
import videoChatPNG from './assets/video-chat.png';
import videoChat from './assets/video-chat.webp';

interface Props {
  onDismiss: () => void;
  className?: string;
}

const VideoChat: React.FC<Props> = ({ onDismiss, className }) => {
  const { formatMessage } = useIntl();
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.minSizeClientImage}>
        <WebpWithFallback src={videoChatDesktopClient} srcFallback={videoChatDesktopClientPNG} />
      </div>
      <div className={styles.content}>
        <div className={coachMarkStyles.title}>
          <Translation {...TXTWCL_Group_Video_Chat} />
        </div>
        <div className={styles.imageContainer}>
          <WebpWithFallback src={videoChat} srcFallback={videoChatPNG} />
        </div>
        <div className={coachMarkStyles.text}>
          <Translation
            tagName="div"
            {...TXTWCL_See_your_friendsX_and_chat_wit_ELL}
            values={{ gameType: formatMessage(TXTCLI_HoldXem) }}
          />
        </div>
        <div className={classNames(coachMarkStyles.buttonContainer, styles.buttonContainer)}>
          <DismissButton onDismiss={onDismiss} />
        </div>
      </div>
    </div>
  );
};

export default VideoChat;
